import React, { useEffect, useRef } from 'react';
import './LivePreview.css';

interface LivePreviewProps {
  html: string;
  isLoading?: boolean;
}

const LivePreview: React.FC<LivePreviewProps> = ({ html, isLoading = false }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (html && iframeRef.current) {
      const iframe = iframeRef.current;
      const document = iframe.contentDocument;
      
      if (document) {
        document.open();
        document.write(html);
        document.close();
      }
    }
  }, [html]);

  return (
    <div className="live-preview">
      {isLoading && (
        <div className="preview-loading-overlay">
          <div className="loading-spinner" />
          <p>Updating preview...</p>
        </div>
      )}
      
      {!html ? (
        <div className="preview-empty">
          <p>Preview will appear here</p>
        </div>
      ) : (
        <iframe
          ref={iframeRef}
          className="preview-iframe"
          title="Resume Preview"
          sandbox="allow-same-origin"
        />
      )}
    </div>
  );
};

export default LivePreview;

